import { render, staticRenderFns } from "./ASLRemoteHeaderButtonContainer.vue?vue&type=template&id=4493b076&scoped=true"
import script from "./ASLRemoteHeaderButtonContainer.vue?vue&type=script&lang=js"
export * from "./ASLRemoteHeaderButtonContainer.vue?vue&type=script&lang=js"
import style0 from "./ASLRemoteHeaderButtonContainer.vue?vue&type=style&index=0&id=4493b076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493b076",
  null
  
)

export default component.exports